$(document).ready(function() {
    $('.part-number-…').addClass('btn-disabled');
    var currentUrl = window.location.href;
    var pageNumber = currentUrl.split('page=').pop();
    if (currentUrl.includes('blogs/')) {
        var substrUrl = currentUrl.split('blogs/').pop();
    } else if (currentUrl.includes('collections/')) {
        var substrUrl = currentUrl.split('collections/').pop();
    }
    var pageRequest = currentUrl.split('?').pop();
    var subsWOPage = substrUrl.replace(pageRequest, '');
    if (parseInt(pageNumber) > 5 ){
        $('.part-number-' + pageNumber).addClass('attiva');
    };
    
});